var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25837_223986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8327 14.167C10.5552 14.167 10.2943 14.0286 10.1393 13.7961L8.72018 11.667H7.49935C7.03935 11.667 6.66602 11.2937 6.66602 10.8337C6.66602 10.3737 7.03935 10.0003 7.49935 10.0003H9.16602C9.44435 10.0003 9.70435 10.1395 9.85935 10.3712L10.7293 11.6762L12.5868 7.96033C12.7235 7.68866 12.996 7.51199 13.3002 7.50033C13.621 7.49199 13.8902 7.64366 14.0469 7.90366L16.3043 11.667H17.4994C17.9594 11.667 18.3327 12.0403 18.3327 12.5003C18.3327 12.9603 17.9594 13.3336 17.4994 13.3336H15.8327C15.5402 13.3336 15.2685 13.1803 15.1185 12.9295L13.3993 10.0645L11.5785 13.707C11.4452 13.9728 11.181 14.1478 10.8843 14.1661C10.8677 14.167 10.8502 14.167 10.8327 14.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 14.9995C14.9577 14.9995 14.141 14.5328 13.691 13.7828L13.5327 13.5245L13.066 14.4495C12.6743 15.2495 11.8743 15.7745 10.991 15.8245L10.8327 15.8328C9.99102 15.8328 9.21602 15.4162 8.74935 14.7162L7.82435 13.3328H7.49935C6.12435 13.3328 4.99935 12.2078 4.99935 10.8328C4.99935 9.45782 6.12435 8.33282 7.49935 8.33282H9.16602C9.59935 8.33282 10.016 8.44115 10.3827 8.64948L11.0993 7.21615C11.5077 6.39948 12.3243 5.86615 13.241 5.83281C13.5993 5.82448 13.9494 5.88281 14.266 6.01615C12.291 2.90781 9.78268 0.357813 9.60768 0.182813C9.37435 -0.0505209 8.95768 -0.0505209 8.72435 0.182813C8.43268 0.474479 1.66602 7.35782 1.66602 12.4412C1.66602 16.6078 5.03268 19.9995 9.16602 19.9995C12.4077 19.9995 15.1827 17.9078 16.2243 14.9995H15.8327Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25837_223986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodPressure);
export default __webpack_public_path__ + "static/media/blood-pressure.3998cfeb8e09575ead0d1b2670ab12fd.svg";
export { ForwardRef as ReactComponent };